export const resourcesNavData = {
  title: 'Resources',
  additionalColumnHeading: '',
  fullWidthDrawer: true,
  items: [
    {
      title: 'Learning Center',
      openNewTab: false,
      menuItem: false,
      url: '/life-science/learning-center',
      __typename: 'AemTopNavItem',
      level: 1,
      newTag: true,
    },
    {
      title: 'Documents',
      openNewTab: false,
      menuItem: true,
      url: '/documents-search',
      childrens: [
        {
          title: 'Safety Data Sheets (SDS)',
          openNewTab: false,
          menuItem: false,
          url: '/documents-search?tab=sds',
          __typename: 'AemTopNavItem',
          level: 2,
        },
        {
          title: 'Certificates of Analysis (COA)',
          openNewTab: false,
          menuItem: false,
          url: '/documents-search?tab=coa',
          __typename: 'AemTopNavItem',
          level: 2,
        },
        {
          title: 'Certificates of Origin (COO)',
          openNewTab: false,
          menuItem: false,
          url: '/documents-search?tab=coo',
          __typename: 'AemTopNavItem',
          level: 2,
        },
        {
          title: 'Certificates of Quality (COQ)',
          openNewTab: false,
          menuItem: false,
          url: '/documents-search?tab=coq',
          __typename: 'AemTopNavItem',
          level: 2,
        },
      ],
      __typename: 'AemTopNavItem',
      level: 1,
    },
  ],
  additionalLinks: [],
  __typename: 'AemTopNav',
  level: 0,
}
